import { urlAuth } from '@/helpers';
import { mensajeError } from '@/composables/mensajesSwal';
import { httpInstance } from '@/clients/http.request';

export const signInUser = async ({ commit }, user) => {
   try {
      const { email, password } = user;

      const { data } = await httpInstance.unauthenticatedPost(`${urlAuth}`, {
         email,
         password,
      });

      const { access_token, usuario } = data;
      if (process.env.NODE_ENV === 'production' && !access_token) {
         return { ok: false, message: 'Error de servicio.' };
      }
      commit('loginUser', { access_token, usuario });

      // Guardar el token en sessionStorage
      sessionStorage.setItem('access_token', access_token);

      return { ok: true, usuario };
   } catch (error) {
      throw error;
   }
};

export const checkAuthentication = async ({ commit, rootState }) => {
   // Obtener el token desde sessionStorage
   const accessToken = sessionStorage.getItem('access_token');

   if (!accessToken) {
      commit('logout', rootState);
      mensajeError('Inicie sesion de nuevo por favor, su sesion caducó');
      return { ok: false, message: 'No hay token' };
   }

   //TODO: (opcional) ver de checkear un token de sesion
   return { ok: true };
};

export const isBsaUser = async ({ commit, rootState }) => {
   try {
      const usuario = rootState.auth?.usuario;
      const id = usuario?.id_empresa;
      if (usuario != null && (id === 20 || id === 50)) {
         return { ok: true };
      }
      return { ok: false };
   } catch (error) {
      return { ok: false };
   }
};

export const isReportesUser = async ({ commit, rootState }) => {
   const nivel = rootState.auth.usuario.nivel;
   if (nivel >= 2) {
      return { ok: true };
   } else {
      return { ok: false };
   }
};

export const isAutomotorUser = async ({ dispatch, rootState }) => {
   const AUTOMOTOR_SECTION_ID = 3;
   let sections = rootState.main?.sections || [];
   if (!sections.length) {
      await dispatch('main/getInitialData', null, { root: true });
      sections = rootState.main?.sections || [];
   }
   const ok = sections.some(
      (s) => Number(s.id_seccion) === AUTOMOTOR_SECTION_ID,
   );
   return { ok };
};

export const recuperarPassword = async ({ commit }, email) => {
   try {
      await httpInstance.unauthenticatedPost(`${urlAuth}/recover-token`, {
         email,
      });
   } catch (error) {
      throw error;
   }
};

export const validateToken = async ({ commit }, token) => {
   try {
      const { data } = await httpInstance.unauthenticatedGet(
         `${urlAuth}/verify-token?token=${token}`,
      );
      return { ok: true, message: data.message };
   } catch (error) {
      throw error;
   }
};

export const resetPassword = async ({ commit }, { token, newPassword }) => {
   try {
      const { data } = await httpInstance.unauthenticatedPut(
         `${urlAuth}/reset`,
         {
            token,
            newPassword,
         },
      );
      return { ok: true, message: data.message };
   } catch (error) {
      throw error;
   }
};
